import {createContext} from 'react'
import type {ProjectId} from '@package/shared'
import type {DateRange} from '../../../../components/dateRangeSelector/DateRangeSelector.tsx'

export type FiltersContextValue = {
  projectId: ProjectId | null
  setProjectId: (projectId: ProjectId | null) => void

  week: DateRange
  setWeek: (week: DateRange) => void
}

export const FiltersContext = createContext<FiltersContextValue>({} as FiltersContextValue)
